export default "__VITE_ASSET__Wd00fcE1__"